/*
 *
 * StructureTimePicker
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Mar-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import './StructureTimePicker.scss'
import MerchantTimePicker from '@nexidigital/merchanttimepicker'
import { is12HourFormat } from 'Utility/globalMethods'

const StructureTimePicker = ({ formik, field, labelStart, labelEnd }) => (
  <div className='structure_time_picker'>
    <span className='timePicker_container'>
      <MerchantTimePicker
        format={is12HourFormat() ? 'hh:mm aa' : 'hh:mm'}
        label={labelStart}
        name={'start' + field}
        ariaLabel={labelStart}
        value={
          isNaN(formik.values[field].from)
            ? null
            : formik.values[field].from
              ? new Date(formik.values[field].from)
              : moment(formik.values[field].from).format('HH:mm')
        }
        placeholder='hh:mm'
        onChange={(newValue) => formik.setFieldValue(field, { ...formik.values[field], from: moment(newValue) })}
        error={formik.errors?.[field]?.from && formik.errors?.[field]?.from}
      />
      <span className='timePickers-dash'>-</span>
      <MerchantTimePicker
        format={is12HourFormat() ? 'hh:mm aa' : 'hh:mm'}
        label={labelEnd}
        name={'end' + field}
        ariaLabel={labelEnd}
        value={
          isNaN(formik.values[field].to)
            ? null
            : formik.values[field].to
              ? new Date(formik.values[field].to)
              : moment(formik.values[field].to).format('HH:mm')
        }
        placeholder='hh:mm'
        onChange={(newValue) =>
          formik.setFieldValue(field, { ...formik.values[field], to: moment(newValue).add(1, 'second') })
        }
        error={formik.errors?.[field]?.to && ' '}
      />
    </span>
  </div>
)

StructureTimePicker.propTypes = {
  formik: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  labelStart: PropTypes.string,
  labelEnd: PropTypes.string,
  errTimeRange: PropTypes.string
}

StructureTimePicker.defaultProps = {
  // Add here some default propTypes values
}

export default StructureTimePicker
